import React, { useState } from 'react';
import designService from '../../services/designService'; // Assuming you have this service
import '../../App.css';

const DesignForm = ({ onDesignCreated, onCancel }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [tags, setTags] = useState('');
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            const newDesign = await designService.createDesign({ name, description, tags });
            //  console.log("Design created successfully:", newDesign);
            if (onDesignCreated) {
                onDesignCreated(newDesign); // Notify parent component
            }
            // Clear the form
            setName('');
            setDescription('');
            setTags('');
        } catch (error) {
            console.error('Error creating design:', error);
            setError(error.message || 'Could not create design. Please try again.');
        }
    };

    return (
           <div className="design-form-popup">
               <h2>Create New Design</h2>
               {error && <p className="error-message">{error}</p>}
               <form onSubmit={handleSubmit}>
                   <div className="form-group">
                       <label htmlFor="name" className="form-label">Name:</label>
                       <input
                           type="text"
                           id="name"
                           value={name}
                           onChange={(e) => setName(e.target.value)}
                           className="form-input"
                           required
                       />
                   </div>
                   <div className="form-group">
                       <label htmlFor="description" className="form-label">Description:</label>
                       <textarea
                           id="description"
                           value={description}
                           onChange={(e) => setDescription(e.target.value)}
                           className="form-input"
                       />
                   </div>
                   <div className="form-group">
                       <label htmlFor="tags" className="form-label">Tags:</label>
                       <input
                           type="text"
                           id="tags"
                           value={tags}
                           onChange={(e) => setTags(e.target.value)}
                           className="form-input"
                       />
                   </div>
                   <div className="form-actions">
                       <button type="submit" className="form-button primary">Create</button>
                       {onCancel && (
                           <button type="button" onClick={onCancel} className="form-button secondary">Cancel</button>
                       )}
                   </div>
               </form>
           </div>
       );
};

export default DesignForm;